import { z } from "zod";
import { uuid } from "./common";

/**
 * Подтверждение менеджером (ТЗ 04 §2.1, §2.6, AC-AUTH-06): действие выше лимита роли → 403 APPROVAL_REQUIRED;
 * менеджер вводит PIN → одноразовый токен (2 мин), привязанный к действию, объекту и сумме → повтор с `X-Approval-Token`.
 */
export const APPROVAL_ACTIONS = {
  /** Ручная скидка на заказ: лимит — % (max_discount_percent, BR-032) */
  "order.discount": "orders.discount",
  /** Возврат: лимит — сумма, minor units (max_refund_amount) */
  "payment.refund": "payments.refund",
  /** Списание: лимит — стоимость документа, minor units (max_writeoff_amount) */
  "stock.writeoff": "stock_documents.create",
  /** Изъятие из кассы: лимит — сумма, minor units */
  "cash.cash_out": "cash_shifts.cash_out",
  /** Void позиции, уже отправленной на кухню (ТЗ 04 §2.6): без права orders.void — PIN менеджера с этим правом (value = 1) */
  "order.void": "orders.void",
} as const;
export type ApprovalAction = keyof typeof APPROVAL_ACTIONS;
export const APPROVAL_ACTION_CODES = Object.keys(APPROVAL_ACTIONS) as [ApprovalAction, ...ApprovalAction[]];

/** Права, у которых в роли бывает лимит без подтверждения (`role_permissions.conditions.limit`). */
export const LIMITED_PERMISSIONS = ["orders.discount", "payments.refund", "stock_documents.create", "cash_shifts.cash_out"] as const;
export type LimitedPermission = (typeof LIMITED_PERMISSIONS)[number];
/** Единица лимита: процент скидки или деньги в minor units. */
export const LIMIT_UNIT: Record<LimitedPermission, "percent" | "money"> = {
  "orders.discount": "percent", "payments.refund": "money", "stock_documents.create": "money", "cash_shifts.cash_out": "money",
};

/** Лимиты роли: null/нет ключа — без ограничения. */
export const roleLimitsSchema = z.partialRecord(z.enum(LIMITED_PERMISSIONS), z.number().min(0, { error: "Не меньше нуля" }).max(1e13).nullable());
export type RoleLimits = z.output<typeof roleLimitsSchema>;

export const approvalRequestSchema = z.strictObject({
  action: z.enum(APPROVAL_ACTION_CODES),
  /** Объект действия (заказ, оплата…); null — новый документ */
  entityId: uuid.nullable().optional(),
  /** Величина (из details APPROVAL_REQUIRED): токен действует не выше неё */
  value: z.number().min(0).max(1e13),
  pin: z.string().regex(/^\d{4,6}$/, { error: "PIN — 4–6 цифр" }),
});
export type ApprovalRequestInput = z.input<typeof approvalRequestSchema>;
